module.exports = __webpack_public_path__ + "media/assets/images/flags/es-a30816398d1c488f4f8fefe9720286f9.svg";